module.exports = {"default":"Default theme","dark":"Dark"}


//////////////////
// WEBPACK FOOTER
// ./src/styles/themes.json
// module id = 1326
// module chunks = 0